exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer{\n  position: fixed;\n  bottom: 0;\n}\n.footer .container{\n    width: 100%;\n}\nul{\n  list-style: none;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0;\n  padding: 0;\n  color: #777;\n  font-size: 80%;\n}\nli{\n  margin-right: 15px;\n  list-style-type: none;\n}\nli>a{\n  color: #777;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/partials/footer/footer.component.css
// module id = 793
// module chunks = 0